/* RPGBound — behaviour (auto-generated, 1:1 with prototype) */
document.addEventListener('DOMContentLoaded', function () {

  // FAQ accordion
  document.querySelectorAll('.faq-item').forEach(item => {
    item.addEventListener('toggle', () => {
      if (item.open) {
        document.querySelectorAll('.faq-item').forEach(other => {
          if (other !== item) other.open = false;
        });
      }
    });
  });

  // Gallery thumbnail swap
  const mainImg = document.getElementById('galleryMain');
  document.querySelectorAll('.gallery-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      mainImg.src = thumb.dataset.src;
    });
  });

  // ============== Variant selector (data-driven, live Shopify) ==============
  var variantInput = document.getElementById('rpgb-variant-id');
  var priceNow = document.getElementById('priceNow');
  var priceWas = document.getElementById('priceWas');
  var priceSave = document.getElementById('priceSave');
  var mainCtaLabel = document.getElementById('mainCtaLabel');
  var stickyPrice = document.getElementById('stickyPrice');
  var stickyMeta = document.getElementById('stickyMeta');
  document.querySelectorAll('.variant').forEach(function (el) {
    el.addEventListener('click', function () {
      document.querySelectorAll('.variant').forEach(function (e) { e.classList.remove('selected'); });
      el.classList.add('selected');
      var radio = el.querySelector('input'); if (radio) radio.checked = true;
      var price = el.dataset.variantPrice || '';
      var was = el.dataset.variantCompare || '';
      var save = el.dataset.variantSave || '';
      var cta = el.dataset.cta || ('Add to Cart — ' + price);
      var sMeta = el.dataset.stickyMeta || '';
      if (variantInput && el.dataset.variantId) variantInput.value = el.dataset.variantId;
      if (priceNow) priceNow.textContent = price;
      if (priceWas) { priceWas.textContent = was; priceWas.style.display = was ? '' : 'none'; }
      if (priceSave) { priceSave.textContent = save; priceSave.style.display = save ? '' : 'none'; }
      if (mainCtaLabel) mainCtaLabel.textContent = cta;
      if (stickyPrice) stickyPrice.innerHTML = was ? (price + ' <span class="was">' + was + '</span>') : price;
      if (stickyMeta) stickyMeta.textContent = sMeta;
    });
  });

  // ============== Preview modal ==============
  const adventures = {
    lighthouse: {
      cover: "https://cdn.shopify.com/s/files/1/0927/4621/9905/files/lhcover2.png?v=1775761049",
      volume: "Volume I · 2.5 hours",
      title: "Lighthouse Keepers",
      sub: "A storm, a lantern, and the light between you.",
      readAloud: "\"The lighthouse keeper turns to you, salt-spray catching in their hair. 'Whatever's out there in the fog,' they say, 'it knows our names. Do you trust me to hold the lantern — or will you?'\"",
      genre: "Romance · Survival",
      duration: "2.5 hours",
      tone: "Cozy peril",
      desc: "A magical storm is rolling in. The light must stay lit. The two of you — keeper and visitor — have one night to figure out what's in the fog, and whether you trust each other enough to face it. Short, warm, and a perfect way to find your voices together."
    },
    hearts: {
      cover: "https://cdn.shopify.com/s/files/1/0927/4621/9905/files/shcover2.png?v=1775761036",
      volume: "Volume II · 3 hours",
      title: "Stolen Hearts",
      sub: "A heist. A masquerade. A velvet promise.",
      readAloud: "\"The Velvet Fox slides the second mask across the table. 'One job,' they say. 'In, out, no one bleeds. Unless you want to kiss me on the way down — in which case, I'll take the longer route.'\"",
      genre: "Heist · Mystery",
      duration: "3 hours",
      tone: "Flirty noir",
      desc: "Two thieves. One locked vault inside a corrupt lord's masquerade ball. Plot the score together at the start. Improvise when the plan inevitably falls apart. Decide which of you walks out clean — and which of you came back for the other one anyway. The longest adventure in the box, and the favourite among returning buyers."
    },
    starlight: {
      cover: "https://cdn.shopify.com/s/files/1/0927/4621/9905/files/sscover2.png?v=1775761053",
      volume: "Volume III · 3 hours",
      title: "Starlight Serenade",
      sub: "A song from the dark — and someone is listening back.",
      readAloud: "\"Beneath constellations neither of you has names for, the music drifts up out of the grass. Your partner reaches for your hand. The song is asking a question. You can both feel it.\"",
      genre: "Fantasy · Slow Burn",
      duration: "3 hours",
      tone: "Cinematic, tender",
      desc: "A celestial mystery, told in three movements. Built for the night you both want to go somewhere else entirely — somewhere with foreign stars, a song that keeps starting and stopping, and a creature that might be a friend, or a memory, or both. The most ambitious adventure in the collection."
    }
  };

  const previewModal = document.getElementById('previewModal');
  const pvCover = document.getElementById('pvCover');
  const pvVolume = document.getElementById('pvVolume');
  const pvTitle = document.getElementById('pvTitle');
  const pvSub = document.getElementById('pvSub');
  const pvReadAloud = document.getElementById('pvReadAloud');
  const pvGenre = document.getElementById('pvGenre');
  const pvDuration = document.getElementById('pvDuration');
  const pvTone = document.getElementById('pvTone');
  const pvDesc = document.getElementById('pvDesc');
  const pvCta = document.getElementById('pvCta');

  function openPreview(key) {
    const a = adventures[key];
    if (!a) return;
    pvCover.src = a.cover;
    pvCover.alt = a.title;
    pvVolume.textContent = a.volume;
    pvTitle.textContent = a.title;
    pvSub.textContent = a.sub;
    pvReadAloud.textContent = a.readAloud;
    pvGenre.textContent = a.genre;
    pvDuration.textContent = a.duration;
    pvTone.textContent = a.tone;
    pvDesc.textContent = a.desc;
    previewModal.classList.add('open');
    previewModal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('rpgb-modal-open');
  }

  function closePreview() {
    previewModal.classList.remove('open');
    previewModal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('rpgb-modal-open');
  }

  // Bind cover clicks
  document.querySelectorAll('.vol-cover[data-vol]').forEach(cover => {
    const key = cover.dataset.vol;
    cover.addEventListener('click', () => openPreview(key));
    cover.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        openPreview(key);
      }
    });
  });

  // Close handlers
  document.getElementById('previewClose').addEventListener('click', closePreview);
  previewModal.addEventListener('click', (e) => {
    if (e.target === previewModal) closePreview();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && previewModal.classList.contains('open')) closePreview();
  });

  // CTA inside modal scrolls to main ATC
  pvCta.addEventListener('click', () => {
    closePreview();
    setTimeout(() => {
      document.getElementById('mainCta').scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, 200);
  });

});
